import React from 'react';
import classNames from 'classnames';
import { scaleLinear as d3scaleLinear } from 'd3-scale';

import ChartBase, { formatClassName, formatNumber, humanizeNumber, useChartBase } from './chart-base';

const BarChart = (props) => {
  const base = useChartBase(props);

  function getClassName() {
    const filters = props.filters || [];
    const isFiltered = filters.length;
    const isNegated = isFiltered && filters[0].is_negated;
    return classNames('bar-chart', { 'is-negated': isNegated });
  }

  function renderChart() {
    const config = props.config;
    const filters = props.filters || [];
    const value_series = config.ds + '.' + config.id;
    const values = props.values[value_series] || {};

    let chartIsNegated = 0;
    if (filters.length > 0) {
      filters.forEach(filter => {
        if (filter.is_negated) {
          chartIsNegated = 1;
        }
      });
    }
    if (chartIsNegated) {
      filters.forEach(filter => filter.is_negated = 1);
    }

    let labels = config.value_labels;
    const updatedLabelList = base.updatedLabelList;

    if (updatedLabelList && base.searchText.length) {
      labels = updatedLabelList;
    }

    if (updatedLabelList && !Object.keys(updatedLabelList).length) {
      return <div className="flex-row">No Values Found</div>;
    }

    if (!labels || Object.keys(labels).length === 0) {
      labels = new Map();
      Object.entries(values).forEach(([val, _]) => labels[val] = val);
    }

    const valuesArray = Object.values(values);
    const maxValue = valuesArray.length ? Math.max.apply(null, valuesArray) : 0;
    const scale = d3scaleLinear()
      .range([0, 100])
      .domain([0, maxValue]);

    return Object.entries(labels).map(([val, label]) => {
      const value = values[val] || 0;
      const filterEntry = filters.find(filter => filter.value === val);
      const isFiltered = filterEntry;
      const isNegated = isFiltered && filterEntry.is_negated;

      return (
        <div className='value-wrapper' key={label}>
          <div className='selected-icon'>
            {isFiltered ? <i className="fa fa-star" /> : ""}
          </div>
          <div
            className={classNames('value', `value-${formatClassName(label)}`, {
              selected: isFiltered,
              not: isNegated || chartIsNegated
            })}
            title={`${label}: ${formatNumber(value)}`}
            onClick={() => base.onFilterClick(!isFiltered, config, value_series, val, chartIsNegated)}
          >
            <div className='bar bar-back'></div>
            <label className='outer max-width-80'>{label}</label>
            <div className='bar' style={{ '--value': `${scale(value).toFixed(2)}%` }}>
              <label className='inner'>{label}</label>
            </div>
            <div className='text-end ms-auto inner-wrapper'>{humanizeNumber(value)}</div>
          </div>
        </div>
      );
    });
  }

  return (
    <ChartBase
      {...props}
      base={base}
      chartClassName={getClassName()}
    >
      <div className={getClassName()}>
        {renderChart()}
      </div>
    </ChartBase>
  );
};

export default BarChart;
